<div class="support-manager-wrap">

  <!-- Page Header -->
  <div class="page-header">
    <div class="header-left">
      <div class="header-icon-box">
        <span class="material-symbols-outlined">headset_mic</span>
      </div>
      <div>
        <h2>Support Tickets</h2>
        <p>Manage and respond to user support requests</p>
      </div>
    </div>
    <div class="header-right">
      <div class="report-counter-pill">
        <span class="material-symbols-outlined">confirmation_number</span>
        {{ tickets.length }} Ticket{{ tickets.length !== 1 ? 's' : '' }}
      </div>
      <button class="btn-refresh" (click)="loadTickets()" [disabled]="loading">
        <span class="material-symbols-outlined" [class.spin]="loading">refresh</span>
        Refresh
      </button>
    </div>
  </div>

  <!-- Status Tabs -->
  <div class="status-tabs-bar">
    <button
      *ngFor="let tab of tabs"
      class="tab-btn"
      [class.active]="activeTab === tab"
      (click)="selectTab(tab)">
      {{ tab === 'ALL' ? 'All Tickets' : tab }}
      <span class="tab-badge" [class.badge-pending]="tab === 'New'" [class.badge-action]="tab === 'Waiting for User'">{{ getTabCount(tab) }}</span>
    </button>
  </div>

  <!-- Loading -->
  <div class="loading-state" *ngIf="loading">
    <span class="material-symbols-outlined spin">progress_activity</span>
    <p>Loading tickets...</p>
  </div>

  <!-- Content: Table + Thread Panel -->
  <div class="content-layout" *ngIf="!loading">

    <!-- LEFT: Ticket Table -->
    <div class="table-panel" [class.panel-shrunk]="selectedTicket">

      <div class="empty-state" *ngIf="filteredTickets.length === 0">
        <div class="empty-icon-circle">
          <span class="material-symbols-outlined">mark_email_read</span>
        </div>
        <h3>No Tickets Found</h3>
        <p>There are no support tickets with status "{{ activeTab }}"</p>
      </div>

      <div class="tickets-table-wrap" *ngIf="filteredTickets.length > 0">
        <table class="tickets-table">
          <thead>
            <tr>
              <th>Ticket</th>
              <th *ngIf="!selectedTicket">User</th>
              <th>Category</th>
              <th>Status</th>
              <th>Priority</th>
              <th *ngIf="!selectedTicket">Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ticket of filteredTickets"
                [class.row-selected]="selectedTicket?.ticket_id === ticket.ticket_id"
                [class.row-unread]="ticket.admin_unread_count > 0">
              <td>
                <div class="td-ticket">
                  <div class="ticket-id-tag">{{ ticket.ticket_id }}</div>
                  <div class="ticket-subject-text" [title]="ticket.subject">{{ ticket.subject }}</div>
                  <div class="unread-indicator" *ngIf="ticket.admin_unread_count > 0">
                    <span class="material-symbols-outlined">mark_unread_chat_alt</span>
                    {{ ticket.admin_unread_count }} new
                  </div>
                </div>
              </td>
              <td *ngIf="!selectedTicket">
                <div class="td-user">
                  <div class="user-avatar-mini">{{ getUserName(ticket.user_id).charAt(0) }}</div>
                  <div>
                    <div class="user-name-sm">{{ getUserName(ticket.user_id) }}</div>
                    <div class="user-email-sm">{{ getUserEmail(ticket.user_id) }}</div>
                  </div>
                </div>
              </td>
              <td>
                <span class="cat-pill">
                  <span class="material-symbols-outlined">{{ getCategoryIcon(ticket.category) }}</span>
                  {{ ticket.category }}
                </span>
              </td>
              <td>
                <span class="status-badge" [ngClass]="getStatusClass(ticket.status)">{{ ticket.status }}</span>
              </td>
              <td>
                <span class="priority-badge" [ngClass]="getPriorityClass(ticket.priority)">{{ ticket.priority }}</span>
              </td>
              <td *ngIf="!selectedTicket">
                <span class="date-sm">{{ ticket.created_at | date:'d MMM y' }}</span>
              </td>
              <td>
                <button class="btn-view-ticket" (click)="openTicket(ticket)">
                  <span class="material-symbols-outlined">open_in_full</span>
                  {{ selectedTicket?.ticket_id === ticket.ticket_id ? 'Viewing' : 'Open' }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- RIGHT: Ticket Thread Panel -->
    <div class="thread-panel" *ngIf="selectedTicket">
      <!-- Thread Header -->
      <div class="thread-header">
        <div class="th-meta">
          <div class="th-ticket-id">{{ selectedTicket.ticket_id }}</div>
          <div class="th-subject">{{ selectedTicket.subject }}</div>
        </div>
        <div class="th-controls">
          <select class="ctrl-select" [value]="selectedTicket.status" (change)="updateStatus($any($event.target).value)" [disabled]="updatingStatus">
            <option *ngFor="let s of statuses" [value]="s">{{ s }}</option>
          </select>
          <select class="ctrl-select priority-select" [value]="selectedTicket.priority" (change)="updatePriority($any($event.target).value)" [disabled]="updatingPriority">
            <option *ngFor="let p of priorities" [value]="p">{{ p }}</option>
          </select>
          <button class="btn-close-panel" (click)="closeSelected()" title="Close panel">
            <span class="material-symbols-outlined">close</span>
          </button>
        </div>
      </div>

      <!-- User Info Bar -->
      <div class="user-info-bar">
        <div class="uib-avatar">{{ getUserName(selectedTicket.user_id).charAt(0) }}</div>
        <div class="uib-details">
          <div class="uib-name">{{ getUserName(selectedTicket.user_id) }}</div>
          <div class="uib-meta">
            <span><span class="material-symbols-outlined">mail</span>{{ getUserEmail(selectedTicket.user_id) }}</span>
            <span><span class="material-symbols-outlined">call</span>{{ getUserMobile(selectedTicket.user_id) }}</span>
          </div>
        </div>
        <div class="uib-badges">
          <span class="status-badge" [ngClass]="getStatusClass(selectedTicket.status)">{{ selectedTicket.status }}</span>
          <span class="priority-badge" [ngClass]="getPriorityClass(selectedTicket.priority)">{{ selectedTicket.priority }}</span>
        </div>
      </div>

      <!-- Loading Thread -->
      <div class="thread-loading" *ngIf="loadingThread">
        <span class="material-symbols-outlined spin">progress_activity</span>
        <p>Loading conversation...</p>
      </div>

      <!-- Messages Thread -->
      <div class="messages-scroll" *ngIf="!loadingThread">
        <!-- Info Banner -->
        <div class="ticket-info-banner">
          <span><span class="material-symbols-outlined">{{ getCategoryIcon(selectedTicket.category) }}</span> {{ selectedTicket.category }}</span>
          <span *ngIf="selectedTicket.screenshot_url">
            <a [href]="selectedTicket.screenshot_url" target="_blank" class="screenshot-link">
              <span class="material-symbols-outlined">image</span> View Screenshot
            </a>
          </span>
          <span><span class="material-symbols-outlined">schedule</span> {{ selectedTicket.created_at | date:'medium' }}</span>
        </div>

        <!-- Messages -->
        <div class="messages-list">
          <div
            *ngFor="let msg of selectedTicket.messages; trackBy: trackByMsg"
            class="msg-bubble"
            [class.msg-user]="msg.sender_type === 'user'"
            [class.msg-admin]="msg.sender_type === 'admin' && !msg.is_internal_note"
            [class.msg-note]="msg.is_internal_note">

            <div class="msg-avatar-sm">
              <span class="material-symbols-outlined">
                {{ msg.sender_type === 'user' ? 'person' : (msg.is_internal_note ? 'sticky_note_2' : 'support_agent') }}
              </span>
            </div>
            <div class="msg-content">
              <div class="msg-header-row">
                <span class="msg-sender-name">
                  {{ msg.sender_type === 'user' ? getUserName(selectedTicket.user_id) : msg.sender_name || 'Support Team' }}
                </span>
                <span class="msg-note-tag" *ngIf="msg.is_internal_note">
                  <span class="material-symbols-outlined">lock</span> Internal Note
                </span>
                <span class="msg-time-sm">{{ msg.created_at | date:'d MMM, h:mm a' }}</span>
              </div>
              <div class="msg-text-body">{{ msg.message }}</div>
            </div>
          </div>
          <div #messagesEnd></div>
        </div>
      </div>

      <!-- Reply Box (Admin) -->
      <div class="admin-reply-box" *ngIf="!loadingThread && selectedTicket.status !== 'Closed'">
        <!-- Internal Note Toggle -->
        <div class="reply-mode-bar">
          <button class="mode-btn" [class.mode-active]="!isInternalNote" (click)="isInternalNote = false">
            <span class="material-symbols-outlined">reply</span>
            Reply to User
          </button>
          <button class="mode-btn mode-note" [class.mode-active]="isInternalNote" (click)="isInternalNote = true">
            <span class="material-symbols-outlined">sticky_note_2</span>
            Internal Note
          </button>
        </div>

        <div class="reply-input-wrap" [class.note-mode]="isInternalNote">
          <div class="note-warning" *ngIf="isInternalNote">
            <span class="material-symbols-outlined">visibility_off</span>
            Internal notes are only visible to admins — not to the user.
          </div>
          <textarea
            class="reply-ta"
            [(ngModel)]="replyText"
            [placeholder]="isInternalNote ? 'Add an internal note for the support team...' : 'Type your reply to the user...'"
            rows="4"
            (keydown.control.enter)="sendReply()">
          </textarea>
          <div class="reply-footer">
            <span class="hint-text">Ctrl+Enter to send</span>
            <button
              class="btn-send"
              [class.btn-send-note]="isInternalNote"
              (click)="sendReply()"
              [disabled]="!replyText.trim() || sendingReply">
              <span class="material-symbols-outlined" [class.spin]="sendingReply">
                {{ sendingReply ? 'progress_activity' : (isInternalNote ? 'sticky_note_2' : 'send') }}
              </span>
              {{ sendingReply ? 'Sending...' : (isInternalNote ? 'Save Note' : 'Send Reply') }}
            </button>
          </div>
        </div>

        <!-- Quick Actions -->
        <div class="quick-actions">
          <button class="qa-btn qa-resolve" (click)="updateStatus('Resolved')" [disabled]="selectedTicket.status === 'Resolved'">
            <span class="material-symbols-outlined">task_alt</span>
            Mark Resolved
          </button>
          <button class="qa-btn qa-close" (click)="updateStatus('Closed')" [disabled]="selectedTicket.status === 'Closed'">
            <span class="material-symbols-outlined">archive</span>
            Close Ticket
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
